export default{
    async getCurrentStats(){
        return await this.$axios.$get(
            this.$api.tenantAdmin.stats.getCurrentStats
        )
    },

    async getDailyUsingCounts({commit}, searchData){
        commit('setTimeRangeDaily', searchData);
        return await this.$axios.$post(
            this.$api.tenantAdmin.stats.getDailyUsingCounts,
            searchData
        )
    },

    async getHourlyUsingUserNumber({commit}, date){
        commit('setTimeRangeHourly', date);
        return await this.$axios.$post(
            this.$api.tenantAdmin.stats.getHourlyUsingUserNumber,
            date
        )
    },


    async downloadCsvHourlyUsingUserNumber({}, params){
        return this.$downloader.downloadPost(this.$axios, this.$api.tenantAdmin.stats.downloadCsvHourlyUsingUserNumber, params)
        .catch(error => {
        });
    },

    async downloadCsvDailyUsingCounts({}, params){
        return this.$downloader.downloadPost(this.$axios, this.$api.tenantAdmin.stats.downloadCsvDailyUsingCounts, params)
        .catch(error => {
        });
    },
}